// read all the error messages from this file to maintain consistency across the codebase

export const NOTIFICATION_MESSAGES = {
   ALREADY_DISTRIBUTED: 'Already distributed',
   CHANGES_DISCARD_SUCCESS: 'Changes discard successfully',
   CHANGES_NOT_SAVED: 'Please save your existing changes',
   CHANGES_SAVED_SUCCESSFULLY: 'Changes saved successfully',
   DAY_VALIDATION: 'Please select Days',
   DISTRIBUTION_APPROVED_SUCCESS: 'Distribution group approved successfully',
   DISTRIBUTION_DELETE_SUCCESS: 'Distribution group deleted successfully',
   DISTRIBUTION_GROUP_DOES_NOT_EXIST:
      'Distribution group is either in distributed state or does not exist',
   DISTRIBUTION_NUMBER_MAX_LENGTH:
      'Distribution group number length should be 6 digits',
   DISTRIBUTION_REMOVED_SUCCESS: 'Distribution group removed successfully',
   DISTRIBUTION_SAVED_SUCCESS: 'Distribution group saved successfully',
   EMPTY_CLIPBOARD_DATA: 'Nothing to paste',
   EMPTY_DISTRIBUTION_NOTE: 'Distribution Log Input text field is empty',
   EMPTY_FIELD: 'Required field is empty',
   EMPTY_QUERY_NAME: 'Query name is empty',
   EMPTY_SEARCH_CRITERIA: 'Search criteria is empty',
   EMPTY_TARIFF_VALUE: 'Tariff number field is empty',
   ENSURE_NO_PERSONAL_DATA_MESSAGE:
      'Kindly ensure that no personal data is entered herein',
   FAILED_TO_DELETE: 'Failed to delete record(s)',
   FAILED_TO_SAVE_CHANGES: 'Failed to save changes',
   FILL_ALL_MANDATORY_FIELDS: 'Please fill all mandatory fields',
   FILE_ATTACHMENTS_UNAVAILABLE: 'No file attachments are available',
   HOUR_VALIDATION: 'Please select Hours',
   INCORRECT_FILE_TYPE: 'Incorrect file extension',
   INVALID_CLIPBOARD_DATA:
      'This data cannot be pasted. Please check the format and try again',
   INVALID_CSV_FILE: 'Please upload a valid csv file',
   INVALID_DATE_FORMAT: 'Invalid date format',
   INVALID_DATE_TIME_FORMAT:
      'date time format is invalid, please use DDMMMYY HH:MM format',
   INVALID_DISTRIBUTION_NUMBER: 'Invalid distribution number',
   INVALID_EMAIL: 'Invalid email format',
   INVALID_ID:
      'Invalid ID! Only alphanumeric characters allowed, max 20 characters',
   INVALID_INPUT: 'Please enter a valid input',
   INVALID_MATH_OPERATION_AMOUNT_FIELD_FORMAT:
      'Amount update must use one of these formats (=+10 ,=-10 ,=*10, =/10).',
   INVALID_SEARCH_COMBINATION:
      'Invalid search criteria. Please enter at least one of the following valid combinations:' +
      '1. ORG & DES' +
      '2. OC & DES' +
      '3. ORG & DC' +
      '4. OC & DC' +
      '5. TAR',
   INVALID_CHARACTER:
      'Invalid character(s) found. Please enter valid character(s)',
   MAX_LENGTH_FOUR_CHARS: 'Please enter a maximum of 4 characters',
   MAX_LENGTH_SIX_CHARS: 'Please enter a maximum of 6 characters',
   MAX_LENGTH_THREE_CHARS: 'Please enter a maximum of 3 characters',
   MAX_LENGTH_EIGHT_CHARS: 'Please enter a maximum of 8 characters',
   MAX_LENGTH_TWENTY_CHARS: 'Please enter a maximum of 20 characters',
   NEW_DISTRIBUTION_GENERATE_SUCCESS:
      'New distribution group generated successfully',
   NO_CHANGES_TO_SAVE: 'No changes to save',
   NO_DATA_AVAILABLE: 'No data available',
   NO_EDIT_MESSAGE: 'No rows have been edited',
   NO_ENCRYPTION_MESSAGE: 'This field is not encrypted',
   NO_RECORD_MESSAGE: 'No record available',
   ONE_CHARACTER_ONLY: 'Please enter only 1 character',
   PAGINATION_IN_PROGRESS:
      'Pagination is in-progress, please wait until pagination is complete',
   QUERY_ALREADY_PRESENT: 'Query already exists',
   QUERY_SAVE_SUCCESS: 'Query name saved successfully',
   RECORD_DELETE_SUCCESS: 'Record(s) deleted successfully',
   RECORD_NOT_UPDATED: 'Please update record(s) and click to save',
   RECORD_UPDATE_SUCCESS: 'Record(s) updated successfully',
   ROW_NOT_SELECTED: 'Please select a row',
   SEARCH_COMPLETED:
      'Successfully fetched all data. Data export is available now',
   INVALID_SPECIFIED_FIELDS:
      'Please select one of the following valid combinations\n1. TAR\n2. ORG + DES\n3. ORG + DC\n4. DES + OC\n5. OC + DC\n5. MKT LST',
   INVALID_CONSTRUCTED_FIELDS:
      'ORG, DES, and CXR are mandatory for constructed.',
   INVALID_ORG_DES: 'Invalid input! Only 3 alphabet characters allowed',
   INVALID_INDICATOR: 'Invalid input! Only 1 alphabet characters allowed',
   SELECT_WORKING_FARES_TO_DELETE:
      'Please select fares with status "Working" to delete',
   INVALID_PRODUCT_TYPE: 'Please select any one product type',
   SEARCH_STOPPED: 'Stopped fetching more data',
   TWO_CHARACTERS_ONLY: 'Please enter 2 characters',
   THREE_CHARACTERS_ONLY: 'Please enter 3 characters',
   MARKET_LIST_MISSING_REQUIRED_FIELDS_MESSAGE:
      'Please fill in all required fields: Market ID, Origin, and Destination.',
};
